import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "../../AuthProvider";
import { useContext, useState, useEffect, useRef } from 'react';
import AuthContext from '../../AuthContext';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Login from "../Login/Login";
import Header from "../Header"
import Dashboard from "../Dashboard/Dashboard";
import Shopping from "../Shopping/Shopping";
import Vault from "../Vault/Vault";
import VaultManagement from "../Vault/VaultManagement";
import UserManagement from "../UserManagement";
import Settings from "../Settings/Settings";
import RecipeBook from "../RecipeBook/RecipeBook";
import PublicRecipe from "../RecipeBook/PublicRecipe";
import NuraImport from "../NuraImport/NuraImport";
import ToastHost from "../Toast/ToastHost";
import RecipeBookContext from "../RecipeBook/RecipeBookContext";

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

function RequireAuth({ children }) {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  if (!user) {
    return <Navigate replace to="/login" state={{ from: location }} />;
  }

  return children;
}

function AppContent() {
  const { user } = useContext(AuthContext);
  const userKey = user ? user.uid : 'anonymous';

  // Shared state for recipe book header
  const [rbState, setRbState] = useState({
    books: [],
    selectedBookId: '',
    selectedBook: null,
    isLoading: true,
    currentView: 'home',
    showAddMenu: false,
    viewingRecipe: null,
    isOwner: false,
    canEditRecipe: false,
    showAddRecipeModal: false,
    recipeBookId: null,
  });

  // Refs that RecipeBook will register its methods into
  const rbRef = useRef({ selectBook: null, setShowAddMenu: null, setShowSearchBar: null, closeRecipeDetail: null, openEditRecipe: null, deleteRecipe: null, shareRecipe: null, shareRecipeLink: null });

  const rbContextValue = {
    ...rbState,
    selectBook: (id) => {
      if (rbRef.current.selectBook) {
        rbRef.current.selectBook(id);
      }
    },
    setShowAddMenu: (v) => {
      if (rbRef.current.setShowAddMenu) {
        rbRef.current.setShowAddMenu(v);
      }
    },
    setShowSearchBar: (v) => {
      if (rbRef.current.setShowSearchBar) {
        rbRef.current.setShowSearchBar(v);
      }
    },
    closeRecipeDetail: () => {
      if (rbRef.current.closeRecipeDetail) {
        rbRef.current.closeRecipeDetail();
      }
    },
    openEditRecipe: (recipe) => {
      if (rbRef.current.openEditRecipe) {
        rbRef.current.openEditRecipe(recipe);
      }
    },
    deleteRecipe: (recipe) => {
      if (rbRef.current.deleteRecipe) {
        rbRef.current.deleteRecipe(recipe);
      }
    },
    shareRecipe: () => {
      if (rbRef.current.shareRecipe) {
        rbRef.current.shareRecipe();
      }
    },
    shareRecipeLink: () => {
      if (rbRef.current.shareRecipeLink) {
        rbRef.current.shareRecipeLink();
      }
    },
  };

  return (
    <RecipeBookContext.Provider value={rbContextValue}>
      <Header/>
      <Routes>
          <Route path="/login" element={<Login />} /> 
          <Route path="/dashboard" element={<RequireAuth><Dashboard key={userKey} /></RequireAuth>} />
          <Route path="/" element={<RequireAuth><Dashboard key={userKey} /></RequireAuth>} />
          <Route path="/shopping" element={<RequireAuth><Shopping key={userKey} /></RequireAuth>} />
          <Route path="/vault" element={<RequireAuth><Vault key={userKey} user={user} /></RequireAuth>} />
            <Route path="/vault-management" element={<RequireAuth><VaultManagement key={userKey} /></RequireAuth>} />
            <Route path="/settings" element={<RequireAuth><Settings key={userKey} /></RequireAuth>} />
          <Route path="/users" element={<RequireAuth><UserManagement key={userKey} /></RequireAuth>} />
          <Route path="/recipes/*" element={<RequireAuth><RecipeBook key={userKey} onStateChange={setRbState} refCallback={(fn) => { rbRef.current = fn; }} /></RequireAuth>} />
          <Route path="/recipe/share/:token" element={<PublicRecipe />} />
          <Route path="/nura-import" element={<RequireAuth><NuraImport key={userKey} /></RequireAuth>} />
      </Routes>
    </RecipeBookContext.Provider>
  );
}

function App() {

  return (
    <ThemeProvider theme={darkTheme}>
      <div className="app">
          <Router>
          <AuthProvider>
              <AppContent />
              <ToastHost />
              </AuthProvider>
              {/* <Route path="/">
                <Redirect to="/login" />
              </Route> */}
          </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;